import React from "react";
import "./AdmissionRequirements.css";
import Header from "./header";
import MyFooter from "./my footer"; 
import gd from './images/newgudoomiye.jpg'

const AdmissionRequirements = () => {
  return (
    <>
      <Header />
      <div className="admission-section">
        {/* Left Image */}
        <div className="admission-image-container">
          <img className="admission-image" src={gd} alt="Admission" />
        </div>

        {/* Right Text */}
        <div className="admission-text">
          <h6 className="section-title text-primary">About Us</h6>
          <h1 className="mb-4">Welcome to E-LEARNING</h1>

          <p className="mb-4">
            <strong>ADMISSION REQUIREMENTS FOR THE BACHELOR DEGREE</strong>
            <br /><br />
            In order for students to join the University they should first fulfill
            the written policy and procedures:
            <br />• Bring secondary certificate (one copy + original)
            <br />• Pass the test and interview
            <br />• Provide 4 passport size photos
            <br />• Pay registration fees $35 (Non-refundable)
            <br />• Bring discipline and conduct letter
            <br />• Medicine candidates → minimum pass mark 80%
            <br />• Engineering candidates → minimum pass mark 75%
          </p>

          <p className="mb-4">
            <strong>GRADING SYSTEM</strong>
            <br />
            All letter grades carry quality points and are computed in student GPAs.
            Each course syllabus indicates the relationship between course components
            and assignments in determining a final grade.
          </p>

          <p className="mb-4">
            <strong>ADMISSION INTAKE</strong>
            <br />
            UNIVERSITY OF SOMALIA (UNISO) has two intakes per year:
            May/August and January/February.
          </p>

          <p className="mb-4">
            <strong>PAYMENT PROCEDURE</strong>
            <br />
            Review your tuition and fee details for the semester.
            <br />
            To pay the registration fee, use:
            <br />
            <strong>*799*00000*35#</strong>
            <br />
            For assistance, contact our finance department.
          </p>

          <p className="mb-4">
            <strong>Grading System</strong>
            <br />
            <b>Marks — Letter — Point — Grade</b>
            <br />90-100 → A → 4.00 → Exceptional
            <br />85-89 → A- → 3.50 → Excellence
            <br />80-84 → B+ → 3.00 → Very Good
            <br />75-79 → B → 2.50 → Good
            <br />70-74 → C+ → 2.00 → Average
            <br />65-69 → C → 1.50 → Pass
            <br />60-64 → D+ → 1.30 → Poor
            <br />50-59 → D → 1.00 → Very Poor
            <br />0-49 → F → 0.00 → Fail
          </p>
        </div>
      </div>
      <MyFooter />
    </>
  );
};

export default AdmissionRequirements;
